import { useState, useEffect } from "react";
import { BrowserRouter, useRoutes } from "react-router-dom";
import Layout from "./pages/Layout";
import Home from "./pages/Home.jsx";
import Impact from "./pages/Impact.jsx";
import Programs from "./pages/Programs.jsx";
import ProgramDetail from "./pages/ProgramDetail.jsx";
import Vedant from "./pages/Vedant.jsx";
import GlobalPresence from "./pages/GlobalPresence.jsx";
import Reports from "./pages/Reports.jsx";
import UpcomingEvent from "./pages/UpcomingEvent.jsx";
import EventDetail from "./pages/EventDetail.jsx";
import NewPage from "./pages/NewPage";
import About from "./pages/About";
import BlogsDetails from "./pages/BlogsDetails";
import AOS from "aos";
import "aos/dist/aos.css";
import Donate from "./pages/Donate";
import DonationForm from "./components/Donate/DonationForm/DonateForm";
import { Toaster } from "react-hot-toast";

import Login from "./pages/Login";
import Profile from "./pages/Profile";

import UserRegister from "./pages/UserRegister";
import EventRegistration from "./pages/EventRegistration";
import ProtectedRoute from "./middlewares/ProtectedRoute";
import ForgotPassword from "./pages/ForgotPassword";
import VerifyOtp from "./pages/VerifyOtp";
import ResetPassword from "./pages/ResetPassword";
import SchedulePage from "./pages/Schedule";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SplashScreen from "./components/SplashScreen";
import NotFound from "./components/NotFound.jsx";

import Volunteer from "./pages/Volunteer.jsx";
// import DikshRegistrationForm from "./pages/MantraDiksha.jsx";

import SuccessPayment from "./pages/SuccessPayment.jsx";
import DeclinePayment from "./pages/DeclinePayment.jsx";
import ManageSubscription from "./pages/ManageSubscription";
import Admin from "./pages/Admin";
import PrivacyPolicy from "./pages/Privacy-Policy";
import RefundPolicy from "./pages/RefundPolicy";
import Terms from "./pages/Terms";
import Transparency from "./pages/Transparency";
import Articles from "./pages/Articles";
import CreateBlog from "./pages/CreateBlog";
import AdminBlogs from "./pages/AdminBlogs";
import Blogs from "./pages/Blogs";

import DikshaInfoForm from "./pages/DikshaInfoForm";
import ScheduleCancel from "./pages/ScheduleCancel";
import ManageBooking from "./pages/ManageBooking";
import FindBooking from "./pages/FindBooking";
import StayConnected from "./pages/StayConnected";
import ScheduleConfirm from "./pages/ScheduleConfirm";
import Rsvp from "./pages/Rsvp";
import EventLanding from "./pages/EventLanding";
import CookiePolicy from "./pages/CookiePolicy";
import CookieConsent from "./components/CookieConsent/CookieConsent";

const protectedRoutes = [
  { path: "/profile", element: <Profile /> },

  { path: "/event-registration", element: <EventRegistration /> },
  { path: "/newpage", element: <NewPage /> },
  { path: "/create-blog", element: <CreateBlog /> },
];

const AppRoutes = () => {
  const [isLoading, setIsLoading] = useState(true);

  const publicRoutes = [
    { path: "/login", element: <Login /> },
    { path: "/admin", element: <Admin /> },
    { path: "/userregister", element: <UserRegister /> },
    { path: "/donate-form", element: <DonationForm /> },
    { path: "/donate-form/:campaignId", element: <DonationForm /> },
    { path: "/success-payment", element: <SuccessPayment /> },
    { path: "/decline-payment", element: <DeclinePayment /> },
    { path: "/manage-subscription", element: <ManageSubscription /> },
    { index: true, element: <Home /> },
    { path: "/impact", element: <Impact /> },
    { path: "/programs", element: <Programs /> },
    { path: "/programs/:programId", element: <ProgramDetail /> },
    { path: "/vedant", element: <Vedant /> },
    { path: "/global-presence", element: <GlobalPresence /> },
    { path: "/reports", element: <Reports /> },
    { path: "/upcoming-event", element: <UpcomingEvent /> },
    { path: "/events/:id", element: <EventDetail /> },
    { path: "blogs/:id", element: <BlogsDetails /> },
    { path: "about", element: <About /> },
    { path: "*", element: <NotFound /> },
    { path: "/forgot-password", element: <ForgotPassword /> },
    { path: "/verify-otp", element: <VerifyOtp /> },
    { path: "/reset-password", element: <ResetPassword /> },
    { path: "/schedule", element: <SchedulePage /> },
    { path: "/volunteer", element: <Volunteer /> },
    { path: "/donate", element: <Donate /> },
    { path: "/privacy-policy", element: <PrivacyPolicy /> },
    { path: "/refund-policy", element: <RefundPolicy /> },
    { path: "/terms", element: <Terms /> },
    { path: "/transparency", element: <Transparency /> },
    { path: "/qr-user-forms", element: <DikshaInfoForm /> },

    { path: "/schedule/cancel", element: <ScheduleCancel /> },
    // Self-service booking editor, reached by the token link in confirmation
    // emails. Sits outside <Layout/> like the cancel page: it is a task page,
    // not a browsing page.
    { path: "/booking/manage", element: <ManageBooking /> },
    // Footer entry point for devotees who no longer have their confirmation
    // email. It only ever mails a link — it never shows a booking on screen.
    { path: "/booking/find", element: <FindBooking /> },
    // Hidden on purpose: reached only from the link in the thank-you email.
    // Not in the navbar, the footer or the sitemap.
    { path: "/connect", element: <StayConnected /> },
    { path: "/schedule/confirm", element: <ScheduleConfirm /> },
    { path: "/rsvp", element: <Rsvp /> },
    { path: "/cookie-policy", element: <CookiePolicy /> },
    { path: "/articles", element: <Articles /> },
    { path: "/blogs", element: <Blogs /> },
    { path: "/create-blog", element: <CreateBlog /> },
    { path: "/admin/blogs", element: <AdminBlogs /> },
  ];

  const routing = useRoutes([
    // Standalone event landing pages — outside <Layout/> on purpose, so they
    // render with no site navbar/footer (shareable event microsites).
    { path: "/e/:id", element: <EventLanding /> },
    {
      path: "/",
      element: <Layout />,
      children: [
        ...publicRoutes,
        {
          element: <ProtectedRoute />,
          children: protectedRoutes,
        },
      ],
    },
  ]);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) return <SplashScreen />;

  return <>{routing}</>;
};

const App = () => {
  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 900,
      easing: "ease-in-sine",
      delay: 100,
    });
    AOS.refresh();
  }, []);

  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <AppRoutes />
      <CookieConsent />
    </BrowserRouter>
  );
};

export default App;
